import React, { useState, useEffect } from 'react';
import { Button } from '../../ui/Button/Button';
import { IconArrowLeft, IconArrowRight } from '../../ui/Icons';
import {
  OnboardingActionsContainer,
  OnboardingActionsSpacer,
  OnboardingActionsNextWrapper,
  OnboardingActionsNextHint
} from '../../ui/Layout/OnboardingLayout';

export const OnboardingActions = ({
  onBack,
  className,
  onNext,
  nextLabel = 'Weiter',
  nextHint,
  nextIcon = true,
  loading = false,
  centered = false
}) => {
  const [activeAction, setActiveAction] = useState(null);

  useEffect(() => {
    if (!loading) {
      setActiveAction(null);
    }
  }, [loading]);

  const handleBackClick = () => {
    if (!onBack || loading) return;
    setActiveAction('back');
    onBack();
  };

  const handleNextClick = () => {
    if (!onNext || loading) return;
    setActiveAction('next');
    onNext();
  };

  const isBackLoading = loading && activeAction === 'back';
  const isNextLoading = loading && activeAction === 'next';

  return (
    <OnboardingActionsContainer $centered={centered} className={className}>
      {onBack ? (
        <Button
          icon={<IconArrowLeft />}
          type="secondaryTransparent"
          onClick={handleBackClick}
          disabled={loading}
          loading={isBackLoading}
        >
          Zurück
        </Button>
      ) : (
        !centered && <OnboardingActionsSpacer />
      )}

      {onNext && (
        <OnboardingActionsNextWrapper $centered={centered}>
          <Button
            type="primary"
            icon={nextIcon && <IconArrowRight />}
            onClick={handleNextClick}
            disabled={loading}
            loading={isNextLoading}
            iconPlacement="end"
          >
            {nextLabel}
          </Button>
          {nextHint && <OnboardingActionsNextHint>{nextHint}</OnboardingActionsNextHint>}
        </OnboardingActionsNextWrapper>
      )}
    </OnboardingActionsContainer>
  );
};
